export default {
  username: '用户名',
  email: '邮箱',
  mobile: '手机'
}